// TWO icon sets (owner 2026-10-21, 47179): this file = the monochrome LINE set for ACTION BUTTONS only; every non-action icon is the colourful emoji set in ./EmojiIcons.jsx (<Emo>, emoText).
// The plain LINE set (owner-chosen 2026-10-08; styleguide Prompts/0.43/ui_foundations_styleguide.html "Action icons: plain line set").
// 24px grid, round caps/joins, currentColor. <IcoLn name> = a glyph next to text / inside .tbl-ico-btn (28px/16px Compact, 34px/20px Comfortable);
// strings in data (labels, messages, config) carry :id: shortcodes rendered by lineText() (nodes), lineHtml() (markup) or stripped by plainText() (titles, confirm()).
// One meaning = one id; a new glyph goes in LINE below AND in the styleguide list (ActionIcons.test.mjs fails otherwise). No literal emoji outside EmojiIcons.jsx.
import React from 'react';
import './iconChips.css';

// ── Tinted-chip LINE icon set (owner-approved 2026-10-08; spec docs Prompts/0.43/ui_foundations_styleguide.html "Action icons: tinted-chip line set", drawings
// Prompts/0.46/46961_icon_set_proposal_v2.html set C). Monochrome 24px-grid glyphs on currentColor; the colour GROUP (blue/purple/grey/amber/red/green) comes with the glyph.
// The emoji <Ico> map is gone: every page uses <IcoLn> / lineText.
const LINE = {
  view: ['blue', '<path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/>'],
  order: ['blue', '<path d="M14 4h6v6"/><path d="M20 4l-9 9"/><path d="M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5"/>'],
  gl: ['purple', '<path d="M12 6.5C10.3 5.2 8 4.5 4 4.5v13c4 0 6.3.7 8 2 1.7-1.3 4-2 8-2v-13c-4 0-6.3.7-8 2z"/><path d="M12 6.5v13"/>'],
  print: ['grey', '<path d="M7 9V4h10v5"/><path d="M7 17H6a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-1"/><rect x="7" y="14" width="10" height="6" rx="1"/>'],
  edit: ['amber', '<path d="M4 20l1-4L16.5 4.5a2 2 0 0 1 3 3L8 19z"/><path d="M14.5 6.5l3 3"/>'],
  trash: ['red', '<path d="M4 7h16"/><path d="M9 7V4h6v3"/><path d="M6 7l1 13h10l1-13"/><path d="M10 11v6"/><path d="M14 11v6"/>'],
  cancel: ['red', '<circle cx="12" cy="12" r="9"/><path d="M5.6 5.6l12.8 12.8"/>'],
  add: ['green', '<circle cx="12" cy="12" r="9"/><path d="M12 8v8"/><path d="M8 12h8"/>'],
  discount: ['green', '<path d="M19 5L5 19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/>'],
  gear: ['grey', '<path d="M4 7h10"/><path d="M18 7h2"/><circle cx="16" cy="7" r="2"/><path d="M4 17h2"/><path d="M10 17h10"/><circle cx="8" cy="17" r="2"/>'],
  more: ['grey', '<circle cx="5" cy="12" r="1.2" fill="currentColor"/><circle cx="12" cy="12" r="1.2" fill="currentColor"/><circle cx="19" cy="12" r="1.2" fill="currentColor"/>'],
  warn: ['amber', '<path d="M12 3.5l9.5 16.5h-19z"/><path d="M12 10v4.5"/><circle cx="12" cy="17.3" r=".9" fill="currentColor"/>'],
  dispatch: ['green', '<rect x="2" y="6" width="11" height="9" rx="1"/><path d="M13 9h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>'],
  delivery: ['green', '<path d="M3.5 7.5L12 3l8.5 4.5v9L12 21l-8.5-4.5z"/><path d="M3.5 7.5L12 12l8.5-4.5"/><path d="M12 12v9"/>'],
  pay: ['green', '<rect x="2.5" y="5.5" width="19" height="13" rx="2"/><path d="M2.5 10h19"/><path d="M6 15h4"/>'],
  invoice: ['blue', '<path d="M6 3h9l4 4v14H6z"/><path d="M14 3v5h5"/><path d="M9 13h6"/><path d="M9 17h6"/>'],
  check: ['green', '<path d="M5 12.5l4.5 4.5L19 7.5"/>'],
  lock: ['grey', '<rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>'],
  send: ['blue', '<path d="M21 3L10 14"/><path d="M21 3l-7 18-4-8-8-4z"/>'],
  calendar: ['grey', '<rect x="4" y="5" width="16" height="15" rx="2"/><path d="M4 10h16"/><path d="M8 3v4"/><path d="M16 3v4"/>'],
  flag: ['amber', '<path d="M5 21V4"/><path d="M5 4h11l-2 4 2 4H5"/>'],
  chart: ['blue', '<path d="M4 20V4"/><path d="M4 20h16"/><path d="M8 16v-5"/><path d="M12 16V8"/><path d="M16 16v-3"/>'],
  close: ['grey', '<path d="M6 6l12 12"/><path d="M18 6L6 18"/>'],
  download: ['blue', '<path d="M12 4v11"/><path d="M7 11l5 5 5-5"/><path d="M5 20h14"/>'],
  customers: ['blue', '<circle cx="9" cy="8" r="3.2"/><path d="M3 20c0-3.5 2.7-6 6-6s6 2.5 6 6"/><path d="M16 5.2a3.2 3.2 0 0 1 0 5.6"/><path d="M18 14.4c1.8.7 3 2.5 3 5.6"/>'],
  flock: ['green', '<path d="M4 16c0-4.4 3.2-8 7.5-8 1.4 0 2.6.4 3.5 1.1L18.5 7 18 10.6c.3.7.5 1.5.5 2.4 0 3.6-3 6.5-7 6.5-4.4 0-7.5-1.5-7.5-3.5z"/><circle cx="14.6" cy="11.2" r=".8" fill="currentColor"/><path d="M9 21v-1.5"/><path d="M13 21v-1.5"/>'],
  egg: ['amber', '<path d="M12 3c-3.5 0-6.5 5.5-6.5 10a6.5 6.5 0 0 0 13 0C18.5 8.5 15.5 3 12 3z"/>'],
  feed: ['amber', '<path d="M12 21V8"/><path d="M12 8c-2.5 0-4-1.6-4-4 2.4 0 4 1.6 4 4z"/><path d="M12 8c2.5 0 4-1.6 4-4-2.4 0-4 1.6-4 4z"/><path d="M12 14c-2.5 0-4-1.6-4-4 2.4 0 4 1.6 4 4z"/><path d="M12 14c2.5 0 4-1.6 4-4-2.4 0-4 1.6-4 4z"/>'],
  mortality: ['red', '<path d="M5 11a7 7 0 0 1 14 0c0 2-.8 3.4-2 4.3V19H7v-3.7C5.8 14.4 5 13 5 11z"/><circle cx="9.5" cy="11.5" r="1.3"/><circle cx="14.5" cy="11.5" r="1.3"/><path d="M10 19v-2"/><path d="M14 19v-2"/>'],
  farm: ['green', '<path d="M3 21V10l9-6 9 6v11z"/><path d="M9 21v-6h6v6"/>'],
  home: ['grey', '<path d="M3 11l9-7 9 7"/><path d="M5 10v10h14V10"/><path d="M10 20v-6h4v6"/>'],
  site: ['grey', '<rect x="5" y="3" width="14" height="18" rx="1"/><path d="M9 7h2"/><path d="M13 7h2"/><path d="M9 11h2"/><path d="M13 11h2"/><path d="M10 21v-4h4v4"/>'],
  storage: ['grey', '<path d="M3 9l9-5 9 5v11H3z"/><path d="M7 20v-7h10v7"/><path d="M7 16h10"/>'],
  clipboard: ['grey', '<rect x="5" y="4" width="14" height="17" rx="2"/><path d="M9 4V3h6v1"/><path d="M9 10h6"/><path d="M9 14h6"/>'],
  note: ['grey', '<path d="M6 3h12v18H6z"/><path d="M9 8h6"/><path d="M9 12h6"/><path d="M9 16h3"/>'],
  trend: ['green', '<path d="M3 17l6-6 4 4 8-8"/><path d="M15 7h6v6"/>'],
  trendDown: ['red', '<path d="M3 7l6 6 4-4 8 8"/><path d="M15 17h6v-6"/>'],
  forecast: ['blue', '<path d="M3 17l5-5 4 3 5-6"/><path d="M17 9l4-4" stroke-dasharray="2 2"/><path d="M4 21h16"/>'],
  money: ['green', '<circle cx="12" cy="12" r="9"/><path d="M14.5 9.2c-.6-.8-1.5-1.2-2.5-1.2-1.4 0-2.5.8-2.5 2s1 1.7 2.5 2 2.5.8 2.5 2-1.1 2-2.5 2c-1 0-1.9-.4-2.5-1.2"/><path d="M12 6.5V8"/><path d="M12 16v1.5"/>'],
  pin: ['grey', '<path d="M12 21s-6.5-6-6.5-11a6.5 6.5 0 0 1 13 0c0 5-6.5 11-6.5 11z"/><circle cx="12" cy="10" r="2.3"/>'],
  search: ['grey', '<circle cx="11" cy="11" r="6.5"/><path d="M20 20l-4.5-4.5"/>'],
  scale: ['grey', '<path d="M12 4v16"/><path d="M7 20h10"/><path d="M5 7h14"/><path d="M5 7l-3 7h6z"/><path d="M19 7l-3 7h6z"/>'],
  bell: ['amber', '<path d="M6 17v-6a6 6 0 0 1 12 0v6l1.5 2h-15z"/><path d="M10 21h4"/>'],
  dna: ['purple', '<path d="M8 3c0 5 8 5 8 9s-8 4-8 9"/><path d="M16 3c0 5-8 5-8 9s8 4 8 9"/><path d="M9 7h6"/><path d="M9 17h6"/>'],
  flask: ['purple', '<path d="M9 3h6"/><path d="M10 3v6L4.5 19a1.5 1.5 0 0 0 1.3 2h12.4a1.5 1.5 0 0 0 1.3-2L14 9V3"/><path d="M7.5 15h9"/>'],
  wrench: ['grey', '<path d="M15 5a4 4 0 0 0-4.5 5.3L4 17a2 2 0 0 0 3 3l6.7-6.5A4 4 0 0 0 19 9l-3 3-3-1-1-3z"/>'],
  target: ['red', '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1" fill="currentColor"/>'],
  cart: ['green', '<path d="M3 4h3l2.5 11h9.5l2-8H7"/><circle cx="10" cy="19.5" r="1.3"/><circle cx="17" cy="19.5" r="1.3"/>'],
  transfer: ['blue', '<path d="M4 8h14"/><path d="M14 4l4 4-4 4"/><path d="M20 16H6"/><path d="M10 12l-4 4 4 4"/>'],
  refresh: ['grey', '<path d="M20 11a8 8 0 0 0-14-4L4 9"/><path d="M4 4v5h5"/><path d="M4 13a8 8 0 0 0 14 4l2-2"/><path d="M20 20v-5h-5"/>'],
  filter: ['grey', '<path d="M3 5h18l-7 8v6l-4 2v-8z"/>'],
  folder: ['grey', '<path d="M3 6a1 1 0 0 1 1-1h5l2 2.5h9a1 1 0 0 1 1 1V19a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"/>'],
  archive: ['grey', '<rect x="3" y="4" width="18" height="5" rx="1"/><path d="M5 9v10h14V9"/><path d="M10 13h4"/>'],
  globe: ['blue', '<circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3c3 3 3 15 0 18"/><path d="M12 3c-3 3-3 15 0 18"/>'],
  user: ['blue', '<circle cx="12" cy="8" r="3.5"/><path d="M5 20c0-3.9 3.1-7 7-7s7 3.1 7 7"/>'],
  shield: ['purple', '<path d="M12 3l8 3v6c0 4.5-3.2 8-8 9-4.8-1-8-4.5-8-9V6z"/><path d="M9 12l2 2 4-4"/>'],
  modules: ['grey', '<rect x="4" y="4" width="7" height="7" rx="1"/><rect x="13" y="4" width="7" height="7" rx="1"/><rect x="4" y="13" width="7" height="7" rx="1"/><rect x="13" y="13" width="7" height="7" rx="1"/>'],
  water: ['blue', '<path d="M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11z"/>'],
  thermo: ['red', '<path d="M10 14V5a2 2 0 0 1 4 0v9a4 4 0 1 1-4 0z"/><path d="M12 9v7"/>'],
  manure: ['amber', '<path d="M4 19h16c0-2-1-3-2.5-3.5.5-1.5 0-3-1.5-3.5.2-2-1-4-4-5 .3 2-.5 3-2 3.5C7 11.5 6.5 13 7 14.5 5 15 4 17 4 19z"/>'],
  ship: ['blue', '<path d="M3 15l2 5h14l2-5z"/><path d="M12 15V4l6 6h-6"/>'],
  health: ['green', '<path d="M3 12h4l2-5 4 10 2-5h6"/>'],
  menu: ['grey', '<path d="M4 7h16"/><path d="M4 12h16"/><path d="M4 17h16"/>'],
  comment: ['blue', '<path d="M4 5h16v11H9l-5 4z"/>'],
  calc: ['grey', '<rect x="5" y="3" width="14" height="18" rx="2"/><path d="M8 7h8"/><path d="M8 12h2"/><path d="M14 12h2"/><path d="M8 16h2"/><path d="M14 16h2"/>'],
  save: ['blue', '<path d="M5 3h12l3 3v15H5z"/><path d="M8 3v5h8V3"/><rect x="8" y="13" width="8" height="8"/>'],
  upload: ['blue', '<path d="M12 16V5"/><path d="M7 9l5-5 5 5"/><path d="M5 20h14"/>'],
  bolt: ['amber', '<path d="M13 3L5 14h6l-1 7 8-11h-6z"/>'],
  bot: ['purple', '<rect x="5" y="8" width="14" height="11" rx="2"/><path d="M12 4v4"/><circle cx="9.5" cy="13" r="1" fill="currentColor"/><circle cx="14.5" cy="13" r="1" fill="currentColor"/>'],
  star: ['amber', '<path d="M12 3l2.7 5.8 6.3.8-4.6 4.4 1.2 6.3L12 17.2 6.4 20.3l1.2-6.3L3 9.6l6.3-.8z"/>'],
  seat: ['grey', '<path d="M7 4v9h10v7"/><path d="M7 13v7"/><path d="M7 4h4"/>'],
  crown: ['amber', '<path d="M4 18l-1-10 5 4 4-7 4 7 5-4-1 10z"/>'],
  info: ['blue', '<circle cx="12" cy="12" r="9"/><path d="M12 11v6"/><circle cx="12" cy="7.5" r=".9" fill="currentColor"/>'],
  item: ['grey', '<path d="M12 3l9 5-9 5-9-5z"/><path d="M3 13l9 5 9-5"/>'],
  account: ['green', '<path d="M3 10l9-6 9 6"/><path d="M5 10v8"/><path d="M10 10v8"/><path d="M14 10v8"/><path d="M19 10v8"/><path d="M3 21h18"/>'],
  duplicate: ['purple', '<rect x="8" y="8" width="12" height="12" rx="2"/><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"/>'],
  chain: ['grey', '<path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1"/><path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1"/>'],
  dotRed: ['red', '<circle cx="12" cy="12" r="6" fill="#dc2626" stroke="none"/>'],
  dotOrange: ['amber', '<circle cx="12" cy="12" r="6" fill="#ea580c" stroke="none"/>'],
  dotYellow: ['amber', '<circle cx="12" cy="12" r="6" fill="#d97706" stroke="none"/>'],
  dotGreen: ['green', '<circle cx="12" cy="12" r="6" fill="#16a34a" stroke="none"/>'],
  dotGrey: ['grey', '<circle cx="12" cy="12" r="6" fill="#9ca3af" stroke="none"/>'],
  dotBlue: ['blue', '<circle cx="12" cy="12" r="6" fill="#2563eb" stroke="none"/>'],
  database: ['grey', '<ellipse cx="12" cy="5" rx="8" ry="3"/><path d="M4 5v6c0 1.7 3.6 3 8 3s8-1.3 8-3V5"/><path d="M4 11v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6"/>'],
  chevron: ['grey', '<path d="M6 9l6 6 6-6"/>'],
  refund: ['amber', '<path d="M9 14L4 9l5-5"/><path d="M4 9h9a6 6 0 0 1 0 12h-4"/>'],
  up: ['grey', '<path d="M12 19V5"/><path d="M6 11l6-6 6 6"/>'],
  down: ['grey', '<path d="M12 5v14"/><path d="M6 13l6 6 6-6"/>'],
  bold: ['grey', '<path d="M7 4h6a4 4 0 0 1 0 8H7z"/><path d="M7 12h7a4 4 0 0 1 0 8H7z"/>'],
  italic: ['grey', '<path d="M10 4h8"/><path d="M6 20h8"/><path d="M15 4L9 20"/>'],
};
// One meaning = one icon id (ActionIcons.test.mjs: ids unique, drawings unique, every id listed in the styleguide table).
export const MEANING = {
  view: "Quick view / preview",
  order: "Open the order (full page)",
  gl: "General Ledger / journal / ledger book",
  print: "Print",
  edit: "Edit",
  trash: "Delete",
  cancel: "Cancel / exclude / will not",
  add: "Add / create / new",
  discount: "Discount",
  gear: "Settings / columns / tools",
  more: "More (row menu)",
  warn: "Warning / attention / hint",
  dispatch: "Dispatch (truck)",
  delivery: "Delivery / receipt (box)",
  pay: "Payment",
  invoice: "Invoice / sale / credit note",
  check: "Done / ok / saved",
  lock: "Locked / secured",
  send: "Send / proforma",
  calendar: "Date / schedule / timeline",
  flag: "Flag / milestone",
  chart: "Chart / analytics / report",
  close: "Close / dismiss / clear / remove",
  download: "Download / import / save PDF",
  customers: "Customers / partners",
  flock: "Birds / bands / flock",
  egg: "Eggs / production",
  feed: "Feed / consumption",
  mortality: "Mortality",
  farm: "Farm / farm operations",
  home: "Home / seat view",
  site: "Site / building",
  storage: "Storage / warehouse",
  clipboard: "Review / overview / queue",
  note: "Notes / audit log / transactions",
  trend: "Growth / profit up",
  trendDown: "Decline / drop",
  forecast: "Forecast",
  money: "Money / revenue / cost",
  pin: "Location / this page",
  search: "Search / inspect",
  scale: "Weighing / reconciliation / balance",
  bell: "Alerts",
  dna: "Breed / lifecycle",
  flask: "Engines / rules (lab)",
  wrench: "Supporting engines (tools)",
  target: "Benchmarks / target",
  cart: "Purchasing / procurement",
  transfer: "Transfer / move",
  refresh: "Refresh / re-run / re-allocate",
  filter: "Filters",
  folder: "Projects / categories",
  archive: "Archive",
  globe: "Formatting / general scope",
  user: "Person / user / role",
  shield: "Approvals / admin",
  modules: "Capabilities / modules",
  water: "Water",
  thermo: "Temperature",
  manure: "Droppings",
  ship: "Landed cost / shipping",
  health: "Data health",
  menu: "Menu",
  comment: "Feedback / comment",
  calc: "Expense / calculation",
  save: "Save draft",
  upload: "Export / upload",
  bolt: "Unstamped / fast action",
  bot: "Assistant",
  star: "Default / priority",
  seat: "Seat / held seat",
  crown: "Owner",
  info: "Info / hint",
  item: "Item / stock item",
  account: "Finance account",
  duplicate: "Duplicate / copy",
  chain: "Link / tie",
  dotRed: "Status dot: critical / very bad",
  dotOrange: "Status dot: bad",
  dotYellow: "Status dot: warning",
  dotGreen: "Status dot: good",
  dotGrey: "Status dot: skipped / no data",
  dotBlue: "Status dot: watch",
  database: "Database / data refresh",
  chevron: "Expand / collapse (points down when open)",
  refund: "Refund / return / undo / restore",
  up: "Move up / earlier in order",
  down: "Move down / later in order",
  bold: "Bold text",
  italic: "Italic text",
};
const SVG_ATTR = { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round', 'aria-hidden': 'true', focusable: 'false' };
const glyph = (name, size, sw, cls) => <svg {...SVG_ATTR} width={size} height={size} strokeWidth={sw} className={cls} dangerouslySetInnerHTML={{ __html: LINE[name][1] }} />;

// Plain line set (docs 46960): 1.8 stroke, one green on a white bordered button (28px/16px compact, 34px/20px comfortable).
// 36px tinted chip button (22px glyph, 2.3 stroke). Compact rows: CSS shrinks to 32/20 under .dens-compact. `label` makes it a wide chip with text beside the glyph (menu parents).
// disabled = 35% opacity, still visible, title carries the reason; `soft` keeps it clickable (a menu that explains why every entry is off).
export function IcoChip({ name, label, title, aria, soft, disabled, className = '', children, ...rest }) {
  const off = !!disabled || !!soft;
  return (
    <button type="button" className={`ic-chip ic-ln${LINE[name][0] === 'red' ? ' danger-h' : ''}${label ? ' wide' : ''}${off ? ' dis' : ''} ${className}`.trim()} title={title || aria} aria-label={aria || title} disabled={disabled} aria-disabled={off || undefined} {...rest}>
      {glyph(name, 20, 1.8)}{label ? <span className="ic-lbl">{label}</span> : null}{children}
    </button>
  );
}
// 16px bare glyph next to text (menu items, hints): 2.5 stroke, no chip, tinted by the same group. Never a stand-alone button.
export function IcoInline({ name }) {
  return <span className="ic-inl ic-ln">{glyph(name, 16, 2, 'ic-inline')}</span>;
}

// The PLAIN LINE glyph, always: the Sales surfaces' action/hint glyph (styleguide "Action icons: plain line set").
// Inline next to text = 16px, 2.0 stroke; inside .tbl-ico-btn the CSS sets 1.8 and 16px (Compact) / 20px (.big). link/stop hints are the warning triangle (styleguide).
const ALIAS = { link: 'warn', stop: 'warn' };
export function IcoLn({ name, size = 16, className = '' }) {
  const n = ALIAS[name] || name;
  return <span className={`ico ico-ln ${className}`.trim()} aria-hidden="true" style={size === 16 ? undefined : { '--s': `${size}px` }}>{LINE[n] ? glyph(n, size, 2, 'ic-inline') : null}</span>;
}

// ── Legacy character -> icon id (the codemod table, and the one place that says "this old glyph means THAT icon"). One meaning = one id.
// Strings (labels, config) carry :id: shortcodes; lineText() turns them into <IcoLn> at the render site, plainText() strips them for titles / exports.
const CODE_RE = new RegExp(`:(${Object.keys(LINE).join('|')}):`, 'g');
export function lineText(s) {
  if (typeof s !== 'string' || !s.includes(':')) return s;
  const out = []; let last = 0, m, k = 0; CODE_RE.lastIndex = 0;
  while ((m = CODE_RE.exec(s))) { if (m.index > last) out.push(s.slice(last, m.index)); out.push(<IcoLn key={k++} name={m[1]} />); last = m.index + m[0].length; }
  if (!out.length) return s;
  if (last < s.length) out.push(s.slice(last));
  return out;
}
export const plainText = (s) => (typeof s === 'string' ? s.replace(CODE_RE, '').replace(/^\s+/, '') : s);
export const iconIds = () => Object.keys(LINE);
// HTML-string twin of lineText for the few surfaces that build markup by hand (the create-form mock body): :id: -> the inline 16px svg.
export const lineHtml = (s) => (typeof s === 'string' && s.includes(':') ? s.replace(CODE_RE, (_, k) => `<span class="ico ico-ln" aria-hidden="true"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ic-inline">${LINE[k][1]}</svg></span>`) : s);
